import React, { memo } from 'react'

import { Button, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, oneOf } from 'prop-types'

import { LIBRARY_TAB } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import arrow from 'images/three_d_studio/empty_state/arrow.webp'

const TEXT_KEY_BY_TAB = {
  [LIBRARY_TAB.MODELS]: 'sidebar.library.emptyState.text',
  [LIBRARY_TAB.IMAGES]: 'sidebar.library.emptyState.imagesText',
}

// Off the :three_d_studio_model_picker flag the empty library has no action cards above
// it, so the copy keeps its original spacing and the arrow pointing at the composer.
function EmptyState({ tab = LIBRARY_TAB.MODELS, withArrow = false, onGenerate = null }) {
  const t = useTranslation()

  return (
    <div className={classnames('empty-state', withArrow && 'empty-state--with-arrow')}>
      <p className="empty-state__text cgt-body-base-semibold">
        {t(TEXT_KEY_BY_TAB[tab])}
      </p>
      {onGenerate && (
        <Button
          type="secondary"
          size="tiny"
          actionType="button"
          customClass="empty-state__button"
          onClick={onGenerate}
        >
          {t('sidebar.actions.generateNewImage')}
        </Button>
      )}
      {withArrow && (
        <img
          className="empty-state__arrow"
          src={arrow}
          alt=""
          aria-hidden="true"
          width="58"
          height="22"
        />
      )}
    </div>
  )
}

EmptyState.propTypes = {
  tab: oneOf(Object.values(LIBRARY_TAB)),
  withArrow: bool,
  onGenerate: func,
}

export default memo(EmptyState)
